import React, { FC } from "react";
import { Outlet } from "react-router-dom";
import Head from "./head/Head";

interface LayoutProps {
  title?: string;
  [key: string]: any;
}

const Layout: FC<LayoutProps> = ({ title, ...props }) => {
  return (
    <>
      <Head title={title || "ProcureX BIM"} />
      <div className="nk-app-root">
        <div className="nk-wrap nk-wrap-nosidebar">
          <div className="nk-content">
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
};

export default Layout;
